import { createAction } from 'app-components/flux/core/actionHelpers';

export const getInvestmentIRR = createAction(
  'GET_INVESTMENT_IRR',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const getInvestmentIRRSuccess = createAction('GET_INVESTMENT_IRR_SUCCESS');
export const getInvestmentIRRFailure = createAction('GET_INVESTMENT_IRR_FAILURE');
